/*
 * SC Ostatnio sprzedane — przewijanie kafli.
 *
 * Licznik "sprzedano X temu" został usunięty (09.2026): plakietka z datą
 * zasłaniała zdjęcie i powtórzona kilkanaście razy w rzędzie wyglądała jak
 * podbijany licznik. Karta pokazuje teraz tagi produktu, a status "sprzedane"
 * niesie mała plakietka w rogu. Nie ma tu już żadnego setInterval.
 */
(function () {
  'use strict';

  if (customElements.get('sc-sold-slider')) return;

  var ScSoldSlider = function () {
    return Reflect.construct(HTMLElement, [], ScSoldSlider);
  };
  ScSoldSlider.prototype = Object.create(HTMLElement.prototype);
  ScSoldSlider.prototype.constructor = ScSoldSlider;
  Object.setPrototypeOf(ScSoldSlider, HTMLElement);

  ScSoldSlider.prototype.connectedCallback = function () {
    var self = this;
    this.vp = this.querySelector('[data-viewport]');
    if (!this.vp) return;
    var prev = this.querySelector('[data-prev]');
    var next = this.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { self.go(-1); });
    if (next) next.addEventListener('click', function () { self.go(1); });
  };

  ScSoldSlider.prototype.go = function (kierunek) {
    var kafel = this.vp.querySelector('.sc-sold__slide');
    var style = getComputedStyle(this.vp);
    var odstep = parseFloat(style.columnGap || style.gap) || 0;
    var szer = kafel ? kafel.getBoundingClientRect().width + odstep : 300;
    var krok = parseInt(this.dataset.step, 10) || 1;
    var plynnie = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    this.vp.scrollBy({ left: kierunek * szer * krok, behavior: plynnie });
  };

  customElements.define('sc-sold-slider', ScSoldSlider);
})();